const Zoom = {
    default: "3",

    init(el, setZoom) {
        this.el = el.find('[component="Zoom"]');
        this.input = this.el.find('input[type="range"]');
        this.thicks = this.el.find('.tick');
        this.setZoom = setZoom;

        const templateZoom = localStorage.getItem('templateZoom');
        this.value = templateZoom > 0 ? templateZoom : this.default
        this.set(this.value);

        this.bind();
    },

    bind() {
        this.input.change((evt) => {
            this.set(evt.currentTarget.value);
        })

        this.thicks.click((evt) => {
            this.set(evt.currentTarget.getAttribute('value'));
        })
    },

    set(val) {
        this.value = val;
        this.input.val(val);
        localStorage.setItem('templateZoom', val);
        this.setZoom(val);
    }
};

export default Zoom;